// extracted by mini-css-extract-plugin
export var container = "loading-spinner-module--container--Hj6Pp";
export var loadingSpinner = "loading-spinner-module--loading-spinner--8jhT8";